import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

import Ingredient from "./ingredient";

import { EMPTY_INGREDIENT } from "../lib/constants";

const ActiveIngredients = (props) => {
    const ingredients = props.data || [];
    const addNew = () => {
        props.addItem("activeIngredients", { ...EMPTY_INGREDIENT });
    };
    const updateItems = (value) => {
        props.updateOnChange("activeIngredients", value);
    };
    const activeIngredients = ingredients.map((ingredient, index) => {
        return (
            <Ingredient
                key={ingredient.key}
                index={index}
                data={ingredient}
                updateOnChange={updateItems}
                removeItem={props.removeItem}
                noteMarkList={props.noteMarkList}
            />
        );
    });

    return (
        <div>
            <div className="active-ingredients">{activeIngredients}</div>
            <button name="newIngredient" className="button -primary -small" onClick={addNew}>
                <FontAwesomeIcon icon={faPlus} /> Ingredient
            </button>
        </div>
    );
};

export default ActiveIngredients;
